module.exports = __webpack_public_path__ + "static/media/Tit_1.595b8d77.png";